import {Link} from 'react-router-dom'

const PurchaserReportTableRow = ({row}: any) => {
  return (
    <tr>
      <td>{row.purchaserName}</td>
      <td className='text-center bg-light'>
        {row.total > 0 ? (
          <Link
            to={{
              pathname: '/products/inquiries/all-inquiries',
              search: `?purchaser=${row.purchaserName}`,
            }}
            target='_blank'
            className='cursor-pointer text-dark text-decoration-underline text-hover-primary'
          >
            {row.total}
          </Link>
        ) : (
          row.total
        )}
      </td>
      <td className='text-center'>
        {row.open > 0 ? (
          <Link
            to={{
              pathname: '/products/inquiries/all-inquiries',
              search: `?purchaser=${row.purchaserName}&status=Open`,
            }}
            target='_blank'
            className='cursor-pointer text-dark text-decoration-underline text-hover-primary'
          >
            {row.open}
          </Link>
        ) : (
          row.open
        )}
      </td>
      <td className='text-center'>
        {row.inProgress > 0 ? (
          <Link
            to={{
              pathname: '/products/inquiries/all-inquiries',
              search: `?purchaser=${row.purchaserName}&status=In Progress`,
            }}
            target='_blank'
            className='cursor-pointer text-dark text-decoration-underline text-hover-primary'
          >
            {row.inProgress}
          </Link>
        ) : (
          row.inProgress
        )}
      </td>
      <td className='text-center'>
        {row.pending > 0 ? (
          <Link
            to={{
              pathname: '/products/inquiries/all-inquiries',
              search: `?purchaser=${row.purchaserName}&status=Pending`,
            }}
            target='_blank'
            className='cursor-pointer text-dark text-decoration-underline text-hover-primary'
          >
            {row.pending}
          </Link>
        ) : (
          row.pending
        )}
      </td>
      <td className='text-center'>
        {row.done > 0 ? (
          <Link
            to={{
              pathname: '/products/inquiries/all-inquiries',
              search: `?purchaser=${row.purchaserName}&status=Done`,
            }}
            target='_blank'
            className='cursor-pointer text-dark text-decoration-underline text-hover-primary'
          >
            {row.done}
          </Link>
        ) : (
          row.done
        )}
      </td>
      <td className='text-center'>
        {row.archived > 0 ? (
          <Link
            to={{
              pathname: '/products/inquiries/archived',
              search: `?purchaser=${row.purchaserName}`,
            }}
            target='_blank'
            className='cursor-pointer text-dark text-decoration-underline text-hover-primary'
          >
            {row.archived}
          </Link>
        ) : (
          row.archived
        )}
      </td>
    </tr>
  )
}

export default PurchaserReportTableRow
